import React, {createRef} from "react";

import moment from "moment";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import {SingleDatePicker} from "react-dates";

import Context from "../../../context/Context";
import * as component from "../../util/component";
import "./SDPWrapper.scss";

export default class SDPWrapper extends React.Component {

  nodeRef = createRef();

  constructor(props) {
    super(props);
    let momentObj = moment(new Date());
    let date = props.initialDate;
    if (date !== null && date !== undefined) {
      momentObj = moment(date);
    }
    this.state = component.newState({
      id: component.nextId(),
      focused: true,
      date: momentObj,
    });
    this.onDateChange = this.onDateChange.bind(this);
    this.onFocusChange = this.onFocusChange.bind(this);
  }

  componentDidMount(){
    const node = this.nodeRef && this.nodeRef.current;
    if (node) {
      let table = node.querySelector(".CalendarMonth_table");
      if (table){
        table.setAttribute("tabindex", "0");
      }
    }
  }

  onDateChange(momentObj) {
    //console.log("onDateChange",momentObj);
    this.setState(state => {
      return {
        date: momentObj
      };
    });
    if (momentObj) {
      const date = momentObj.toDate();
      if (this.props.onDateChange) this.props.onDateChange(date);
    }
  }

  onFocusChange(focused) {
    this.setState(state => {
      return {
        focused: true
      };
    });
  }

  render() {
    const {id, date, focused} = this.state;
    const props = {
      keepOpenOnDateSelect: true,
      reopenPickerOnClearDate: true,
      numberOfMonths: 1,
      hideKeyboardShortcutsPanel: true,
      isRTL: Context.getInstance().uiMode.isRtl,
      isDayBlocked: () => false,
      isOutsideRange: () => false
    }
    if (props.isRTL) {
      props.anchorDirection = "right";
    }
    return (
      <div className="i-sdpwrapper" ref={this.nodeRef}>
        <SingleDatePicker
          {...props}
          id={id}
          date={date}
          focused={focused}
          onDateChange={this.onDateChange}
          onFocusChange={this.onFocusChange}
        />
      </div>
    );
  }

}
